import { orderBy, uniqBy } from "lodash";
import { CBSaltospi } from "../../../services/api";

export async function fetchClassesProvas({ idEvento, tipoAparelho, sexo }) {
  const res = await CBSaltospi.get("evento-prova", {
    params: {
      id_evento: idEvento,
      "aparelho.tipo_aparelho": tipoAparelho,
      sexo: sexo,
      expand: "classe,aparelho",
      pageSize: 1000,
    },
  });

  if (res.data._meta.totalCount === 0) {
    return [];
  }

  const classes = res.data.items.map((item) => ({
    id: item.id_classe,
    classe: item.classe,
    aparelho: item.aparelho.tipo_aparelho,
  }));

  const uniqueClasses = uniqBy(classes, "id");

  // Sort by class description
  return orderBy(uniqueClasses, ["classe.descricao"], ["asc"]);
}
